export const sessionNotesConfiguration: any[] = [
    {
        "sectionKey": "MindPlan",
        "subSectionKey": "moodAndFunctioning",
        "subSectionTitle": "Mood and functioning",
        "subHeaderTags": [],
        "subSectionDescription": "",
        "showPastHistory": false,
        "showPastHistoryText": null,
        "isDataRequired": false,
        "validationSchema": null,
        "colWidth": null,
        "modalConfigurationJson": null,
        "subSectionType": null,
        "data": [
            {
                "questionTitle": "",
                "key": "details",
                "class": " ",
                "answerList": [
                    {
                        "type": "RICH_TEXT",
                        "placeholder": "Type here",
                        "key": "text",
                        "trackingConfig": {
                            "events": [
                                {
                                    "name": "click",
                                    "properties": {
                                        "flow": "Therapy Session",
                                        "section": "Session Notes",
                                        "widget": "Mood and functioning"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    },
    {
        "sectionKey": "MindPlan",
        "subSectionKey": "themesExplored",
        "subSectionTitle": "Themes explored",
        "subHeaderTags": [],
        "subSectionDescription": "",
        "showPastHistory": false,
        "showPastHistoryText": null,
        "isDataRequired": false,
        "validationSchema": null,
        "colWidth": null,
        "modalConfigurationJson": null,
        "subSectionType": null,
        "data": [
            {
                "questionTitle": "",
                "key": "details",
                "class": " ",
                "answerList": [
                    {
                        "type": "RICH_TEXT",
                        "placeholder": "Type here",
                        "key": "text",
                        "suggestions": ["Relationship dynamics", "Fear of Failure", "Stress management", "Low self worth", "Need for approval / validation"],
                        "typeAheadConfiguration": {
                            "source": "MAVERICK",
                            "url": "/maverick/care/static_generic_catalogue",
                            "appendQueryString": true,
                            "otherKeysMapping": {
                                "result-size": 5
                            },
                            "additionalParams": {
                                "catalogueName": "themes"
                            },
                            "additionalInfoLabelKeys": [],
                            "valueKey": "internalName",
                            "labelKey": "displayName",
                            "internalKey": "internalName",
                            "inputParam": "q",
                            "allowAddItem": true,
                            "addItemToTypeahead": {
                                "displayText": "Click to add new"
                            },
                            "resultMapper": {
                                "internalValue": "internalValue",
                                "displayValue": "displayValue"
                            }
                        },
                        "trackingConfig": {
                            "events": [
                                {
                                    "name": "click",
                                    "properties": {
                                        "flow": "Therapy Session",
                                        "section": "Session Notes",
                                        "widget": "Themes explored"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    },
    {
        "sectionKey": "MindPlan",
        "subSectionKey": "riskAssessment",
        "subSectionTitle": "Risk Assessment",
        "subHeaderTags": [],
        "subSectionDescription": "",
        "showPastHistory": false,
        "showPastHistoryText": null,
        "isDataRequired": false,
        "validationSchema": null,
        "colWidth": null,
        "modalConfigurationJson": null,
        "subSectionType": null,
        "data": [
            {
                "questionTitle": "",
                "key": "riskPresent",
                "class": " ",
                "answerList": [
                    {
                        "type": "TOGGLE_SWITCH",
                        "key": "noRisk",
                        "textSize": " ",
                        "header": "",
                        "configuration": {
                            "label": "Risk present",
                            "secondLabel": "No Risk present",
                            "default": true,
                            "action": "clear", // [clear | fill]
                            "linkedFieldKeys": [
                                {
                                    "key": "risksInvolvedDetails",
                                    "value": ""
                                },
                                {
                                    "key": "safetyPlan",
                                    "value": ""
                                },
                                {
                                    "key": "emergencyPlan",
                                    "value": ""
                                }
                            ]
                        },
                        "trackingConfig": {
                            "events": [
                                {
                                    "name": "click",
                                    "properties": {
                                        "flow": "Therapy Session",
                                        "section": "Session Notes",
                                        "widget": "Risk assessment",
                                        "field": "Toggle"
                                    }
                                }
                            ]
                        }
                    },
                ]
            },
            {
                "questionTitle": "",
                "key": "risksInvolvedDetails",
                "class": " ",
                "answerList": [
                    {
                        "type": "RICH_TEXT",
                        "placeholder": "Type here",
                        "key": "text",
                        "dependentQues": {
                            "questionKey": "riskPresent",
                            "answerKey": "noRisk"
                        },
                        "trackingConfig": {
                            "events": [
                                {
                                    "name": "click",
                                    "properties": {
                                        "flow": "Therapy Session",
                                        "section": "Session Notes",
                                        "widget": "Risks assessment"
                                    }
                                }
                            ]
                        }
                    }
                ]
            },
            {
                "questionTitle": "",
                "key": "lineDivider",
                "class": " ",
                "answerList": [
                    {
                        "type": "LINE_DIVIDER",
                        "dependentQues": {
                            "questionKey": "riskPresent",
                            "answerKey": "noRisk"
                        }
                    }
                ]
            },
            {
                "questionTitle": "",
                "key": "safetyPlan",
                "class": " ",
                "answerList": [
                    {
                        "type": "RICH_TEXT",
                        "listHeader": "Safety Plan",
                        "placeholder": "Type here",
                        "key": "text",
                        "dependentQues": {
                            "questionKey": "riskPresent",
                            "answerKey": "noRisk"
                        },
                        "trackingConfig": {
                            "events": [
                                {
                                    "name": "click",
                                    "properties": {
                                        "flow": "Therapy Session",
                                        "section": "Session Notes",
                                        "widget": "Risk assessment - Safety Plan"
                                    }
                                }
                            ]
                        }
                    }
                ]
            },
            {
                "questionTitle": "",
                "key": "lineDivider2",
                "class": " ",
                "answerList": [
                    {
                        "type": "LINE_DIVIDER",
                        "dependentQues": {
                            "questionKey": "riskPresent",
                            "answerKey": "noRisk"
                        }
                    }
                ]
            },
            {
                "questionTitle": "",
                "key": "emergencyPlan",
                "class": " ",
                "answerList": [
                    {
                        "type": "RICH_TEXT",
                        "listHeader": "Emergency Plan",
                        "placeholder": "Type here",
                        "key": "text",
                        "dependentQues": {
                            "questionKey": "riskPresent",
                            "answerKey": "noRisk"
                        },
                        "trackingConfig": {
                            "events": [
                                {
                                    "name": "click",
                                    "properties": {
                                        "flow": "Therapy Session",
                                        "section": "Session Notes",
                                        "widget": "Risk assessment - Emergency Plan"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    },
    {
        "sectionKey": "MindPlan",
        "subSectionKey": "assessment",
        "subSectionTitle": "Assessment",
        "subSectionDescription": "",
        "showPastHistory": false,
        "showPastHistoryText": null,
        "isDataRequired": false,
        "validationSchema": null,
        "colWidth": null,
        "modalConfigurationJson": null,
        "subSectionType": null,
        "data": [
            {
                "questionTitle": "",
                "key": "details",
                "class": " ",
                "answerList": [
                    {
                        "type": "RICH_TEXT",
                        "placeholder": "Type here",
                        "key": "text",
                        "suggestions": ["PHQ9 - for depression", "Beck Depression Inventory", "Hamilton Anxiety Scale", "YSQ-L3", "Robson Self Concept Questionnaire"],
                        "typeAheadConfiguration": {
                            "source": "MAVERICK",
                            "url": "/maverick/care/static_generic_catalogue",
                            "appendQueryString": true,
                            "otherKeysMapping": {
                                "result-size": 5
                            },
                            "additionalParams": {
                                "catalogueName": "assessment"
                            },
                            "additionalInfoLabelKeys": [],
                            "valueKey": "internalName",
                            "labelKey": "displayName",
                            "internalKey": "internalName",
                            "inputParam": "q",
                            "allowAddItem": true,
                            "addItemToTypeahead": {
                                "displayText": "Click to add new"
                            },
                            "resultMapper": {
                                "internalValue": "internalValue",
                                "displayValue": "displayValue"
                            }
                        },
                        "trackingConfig": {
                            "events": [
                                {
                                    "name": "click",
                                    "properties": {
                                        "flow": "Therapy Session",
                                        "section": "Session Notes",
                                        "widget": "Assessment"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    },
    {
        "sectionKey": "MindPlan",
        "subSectionKey": "diagnosticImpressions",
        "subSectionTitle": "Clinical Impressions",
        "subHeaderTags": ["Biological formulation", "Psychological formulation", "Case Conceptualisation"],
        "subSectionDescription": "",
        "showPastHistory": false,
        "showPastHistoryText": null,
        "isDataRequired": false,
        "validationSchema": null,
        "colWidth": null,
        "modalConfigurationJson": null,
        "subSectionType": null,
        "data": [
            {
                "questionTitle": "",
                "key": "details",
                "class": " ",
                "answerList": [
                    {
                        "type": "RICH_TEXT",
                        "placeholder": "Type here",
                        "key": "text",
                        "trackingConfig": {
                            "events": [
                                {
                                    "name": "click",
                                    "properties": {
                                        "flow": "Therapy Session",
                                        "section": "Session Notes",
                                        "widget": "Diagnostic Impressions"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    },
    {
        "sectionKey": "MindPlan",
        "subSectionKey": "therapistIntervention",
        "subSectionTitle": "Therapeutic intervention",
        "subHeaderTags": [],
        "subSectionDescription": "",
        "showPastHistory": false,
        "showPastHistoryText": null,
        "isDataRequired": false,
        "validationSchema": null,
        "colWidth": null,
        "modalConfigurationJson": null,
        "subSectionType": null,
        "data": [
            {
                "questionTitle": "",
                "key": "details",
                "class": " ",
                "answerList": [
                    {
                        "type": "RICH_TEXT",
                        "placeholder": "Type here",
                        "key": "text",
                        "suggestions": ["Empty chair technique", "Cognitive diffusion", "Socratic questioning", "Addressed transference", "Reflective listening"],
                        "typeAheadConfiguration": {
                            "source": "MAVERICK",
                            "url": "/maverick/care/static_generic_catalogue",
                            "appendQueryString": true,
                            "otherKeysMapping": {
                                "result-size": 5
                            },
                            "additionalParams": {
                                "catalogueName": "therapeutic_intervention"
                            },
                            "additionalInfoLabelKeys": [],
                            "valueKey": "internalName",
                            "labelKey": "displayName",
                            "internalKey": "internalName",
                            "inputParam": "q",
                            "allowAddItem": true,
                            "addItemToTypeahead": {
                                "displayText": "Click to add new"
                            },
                            "resultMapper": {
                                "internalValue": "internalValue",
                                "displayValue": "displayValue"
                            }
                        },
                        "trackingConfig": {
                            "events": [
                                {
                                    "name": "click",
                                    "properties": {
                                        "flow": "Therapy Session",
                                        "section": "Session Notes",
                                        "widget": "Therapist intervention"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    },
    {
        "sectionKey": "MindPlan",
        "subSectionKey": "progressNotes",
        "subSectionTitle": "Process notes",
        "subHeaderTags": [],
        "subSectionDescription": "",
        "showPastHistory": false,
        "showPastHistoryText": null,
        "isDataRequired": false,
        "validationSchema": null,
        "colWidth": null,
        "modalConfigurationJson": null,
        "subSectionType": null,
        "data": [
            {
                "questionTitle": "",
                "key": "details",
                "class": " ",
                "answerList": [
                    {
                        "type": "RICH_TEXT",
                        "placeholder": "Type here",
                        "key": "text",
                        "trackingConfig": {
                            "events": [
                                {
                                    "name": "click",
                                    "properties": {
                                        "flow": "Therapy Session",
                                        "section": "Session Notes",
                                        "widget": "Progress notes"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    },
    {
        "sectionKey": "MindPlan",
        "subSectionKey": "therapistReferral",
        "subSectionTitle": "Referral",
        "subSectionDescription": "",
        "showPastHistory": false,
        "showPastHistoryText": null,
        "isDataRequired": false,
        "colWidth": null,
        "modalConfigurationJson": null,
        "subSectionType": null,
        "dataToBeSaved": true,
        "isNewTypeList": true,
        "data": [
            {
                "questionTitle": "",
                "key": "referral",
                "trackerKey": "doctorSpecialityCode.displayValue",
                "uniqueKey": "doctorSpecialityCode.displayValue",
                "answerList": [
                    {
                        "type": "TEMPLATED_LIST_V2",
                        "openMode": true,
                        "fields": [
                            {
                                "type": "HEADER",
                                "key": "header",
                                "displayAdditionalInfo": false,
                                "targetKey": "doctorSpecialityCode",
                                "textSize": "small",
                                "header": " ",
                            },
                            {
                                "key": "comments",
                                "type": "TEXT_FIELD",
                                "placeholder": "Comment",
                                "textSize": "large",
                                "header": "Other Advice",
                            }
                        ],
                        "defaultItemFields": [
                            {
                                "key": "doctorSpecialityCode",
                                "type": "TYPEAHEAD",
                                "typeAheadConfiguration": {
                                    "source": "ORION",
                                    "url": "/orion/static/fetch/referral",
                                    "valueKey": "displayValue",
                                    "labelKey": "displayValue",
                                    "internalKey": "internalValue",
                                    "appendQueryString": true,
                                    "inputParam": "q",
                                    "allowAddItem": false,
                                },
                                "placeholder": "Others",
                                "header": "Intake",
                                "inline": false,
                                "enableSearchIcon": true
                            },
                        ],
                        "trackingConfig": {
                            "events": [
                                {
                                    "name": "click",
                                    "properties": {
                                        "flow": "Therapy Session",
                                        "section": "Session Notes",
                                        "widget": "Referral"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    }
]